import { AppPanelsT, routeConfig } from "../lib/routeConfig"
import { AdaptivityProvider, AppRoot, ConfigProvider, View } from "@vkontakte/vkui"
import { useUnit } from "effector-react"
import { $isStandAlone } from "src/entity/User"

interface IVkProviderProps {
  activePanel: AppPanelsT
}

export const RouteProvider = ({ activePanel }: IVkProviderProps) => {
  const [isStandAlone] = useUnit([$isStandAlone])
  return (
    <ConfigProvider appearance="light">
      <AdaptivityProvider>
        <AppRoot id="app" className={`app ${isStandAlone ? "app--standalone" : "app--vkapp"}`}>
          <View activePanel={activePanel}>{routeConfig}</View>
        </AppRoot>
      </AdaptivityProvider>
    </ConfigProvider>
  )
}
